import { partyDocumentDocSubTypeUtils } from './partyDocumentUtils';
export function createAlertDialog({ rule, changedValues, documentProps, t, dialogProps, }) {
    // TODO: This is basically pretty much at the limit of what should be done with only "text" translations. It just gets too confusing.
    // AlertDialog can also handle ReactNode(children) but then I would have to refactor the whole thing.
    // Therefore I leave it as a todo here
    // prepare documents
    const documents = documentProps &&
        `${t('party:communication.document')} ${partyDocumentDocSubTypeUtils.getTranslatedValue(t, documentProps.docSubType)} ${(documentProps.files || [])
            .map((file) => file.file.name)
            .join(', ')}<br /><br />`;
    // prepare ChangedFields
    const changedFields = changedValues
        ?.map((value, index) => `<strong>${t(`party:fields.party${value.key.charAt(0).toUpperCase() + value.key.slice(1)}.label`)}:</strong> ${value.newValue} (${t('party:communication.old_value')} ${value.oldValue}) ${changedValues.length - 1 !== index ? '<br />' : ''}`)
        .join(' ');
    return {
        title: t(`party:communication.${rule}.title`),
        description: t(`party:communication.${rule}.description`, {
            changedFields,
            documents,
        }),
        cancelAction: true,
        cancelText: t('common:button_label.cancel'),
        continueText: t('common:button_label.proceedAnyway'),
        ...dialogProps,
    };
}
